import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTabSection } from '../../contexts/TabSectionContext';
import { Logo } from './Logo';
import { TabNavigation } from './TabNavigation';
import { HeaderActions } from './HeaderActions';
import ailogo from './ainewlogo.png';

const useStyles = makeStyles({
  root: {
    overflow: 'hidden',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    zIndex: 1300,
    minHeight: '80px !important',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    borderBottom: '1px solid #e5e7eb',
    gap: '32px',
    overflow: 'hidden',
    flexWrap: 'nowrap',
  },
  spacer: {
    flex: 1,
  },
  content: {
    flex: 1,
    overflow: 'auto',
  },
});

export const GlobalHeader = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { activeSection, setActiveSection } = useTabSection();

  React.useEffect(() => {
    let section:
      | 'marketplace'
      | 'finops'
      | 'sts'
      | 'creative'
      | 'finance'
      | 'media'
      | 'dx'
      | 'n8n' = 'marketplace';
    if (location.pathname.startsWith('/finops')) section = 'finops';
    else if (location.pathname.startsWith('/sts')) section = 'sts';
    else if (location.pathname.startsWith('/creative')) section = 'creative';
    else if (location.pathname.startsWith('/finance')) section = 'finance';
    else if (location.pathname.startsWith('/media')) section = 'media';
    else if (location.pathname.startsWith('/dx')) section = 'dx';
    else if (location.pathname.startsWith('/n8n')) section = 'n8n';
    if (section !== activeSection) setActiveSection(section);
  }, [location.pathname, activeSection, setActiveSection]);

  const tabs = [
    {
      id: 'marketplace',
      label: 'MARKETPLACE',
      onClick: () => {
        setActiveSection('marketplace');
        navigate('/marketplace');
      },
    },
    {
      id: 'finops',
      label: 'AI GOVERNANCE',
      onClick: () => {
        setActiveSection('finops');
        navigate('/finops');
      },
    },
    {
      id: 'finance',
      label: 'FINANCE',
      onClick: () => {
        setActiveSection('finance');
        navigate('/finance/reporting');
      },
    },
    {
      id: 'dx',
      label: 'DX',
      onClick: () => {
        setActiveSection('dx');
        navigate('/dx');
      },
    },
    {
      id: 'sts',
      label: 'STS',
      onClick: () => { setActiveSection('sts'); navigate('/sts'); },
    }
    // {
    //   id: 'n8n',
    //   label: 'N8N',
    //   onClick: () => { setActiveSection('n8n'); navigate('/n8n/workflows'); },
    // },
  ];

  const handleLogoClick = () => {
    setActiveSection('marketplace');
    navigate('/marketplace');
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Logo src={ailogo} alt="COE Logo" onClick={handleLogoClick} />
        <TabNavigation tabs={tabs} activeTab={activeSection} />
        <Box className={classes.spacer} />
        <HeaderActions />
      </Box>
      <Box className={classes.content}>{children}</Box>
    </Box>
  );
};
